export default "skymp5-front/ec7b866148b752e955df072b31c48472.jpg";